import {EnvironmentProviders, importProvidersFrom, Provider} from "@angular/core";
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalService
} from "@azure/msal-angular";
import {guardConfigFactory, instancePublicClientApp, interceptorConfigFactory} from "./auth.config";
import { HTTP_INTERCEPTORS } from "@angular/common/http";

export const provideAuth = (): (Provider | EnvironmentProviders)[] => {
  return [
    importProvidersFrom(MsalModule),
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    {
      provide: MSAL_INSTANCE,
      useFactory: instancePublicClientApp
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: guardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: interceptorConfigFactory
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    }
  ];
};
